
class Escola {
    constructor(
        public id: number = 0,
        public key: number = 0,
        public value: number = 0,
        public nom: string = "",
        public label: string = "",
        public id_loop: string = "",
        public comentaris: string = "",
        public menjador: boolean = false,
        public extraescolars: boolean = false,
        public casals: boolean = false,
        public referent: string = "",
        public proposta: boolean = false,
        public menu: number = 0
    ) {}
}

export {Escola};
